import { ColumnsType } from "antd/es/table";
import { Space, Dropdown } from "antd";
import { BotoesAcoes } from "../../ViewGerenciarPostagens/styles"; // Botões de ação
import SettingsIcon from "@mui/icons-material/Settings";
import { getMenuItems } from "../constants/itemsActionColumns";
import ColumnSearch from "../../../components/ColumnSearch";

export const Columns = (
  onClick: (e: any) => void,
  setPeriodoId: (e: any) => void,
  setDataEspecial: (e: any) => void,
  setValor: (e: any) => void,
  setCheckIn: (e: any) => void,
  setCheckOut: (e: any) => void,
  filteredInfo: {
    checkIn?: string[] | null;
    checkOut?: string[] | null;
    dataEspecial?: string[] | null;
    origem?: string[] | null;
    valor?: string[] | null;
  }
): ColumnsType<any> => {
  const items = getMenuItems();

  return [
    {
      title: "Check-In",
      dataIndex: "checkIn",
      key: "checkIn",
      width: "30%",
      filteredValue: filteredInfo.checkIn || null,
      onFilter: (value, record) => record.checkIn.includes(value),
      ...ColumnSearch<any>({ dataIndex: "checkIn" }),
    },
    {
      title: "Check-Out",
      dataIndex: "checkOut",
      key: "checkOut",
      width: "30%",
      filteredValue: filteredInfo.checkOut || null,
      onFilter: (value, record) => record.checkOut.includes(value),
      ...ColumnSearch<any>({ dataIndex: "checkOut" }),
    },
    {
      title: "Data Especial",
      dataIndex: "dataEspecial",
      key: "dataEspecial",
      width: "30%",
      filteredValue: filteredInfo.dataEspecial || null,
      onFilter: (value, record) => record.dataEspecial.includes(value),
      ...ColumnSearch<any>({ dataIndex: "dataEspecial" }),
    },
    {
      title: "Origem",
      dataIndex: "origem",
      key: "origem",
      width: "30%",
      filteredValue: filteredInfo.origem || null,
      onFilter: (value, record) => record.origem.includes(value),
      filterSearch: true,

      filters: [
        { text: "Multicotas", value: "Multicotas" },
        { text: "Usuário", value: "Usuário" },
      ],
    },
    {
      title: "Valor período",
      dataIndex: "valor",
      key: "valor",
      width: "30%",
      filteredValue: filteredInfo.valor || null,
      onFilter: (value, record) => record.valor.includes(value),
      filterSearch: true,
      ...ColumnSearch<any>({ dataIndex: "valor" }),
    },

    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "10%",
      align: "center",
      filteredValue: null,
      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                setPeriodoId(row.key);
                setDataEspecial(row.dataEspecial);
                setValor(row.valor);
                setCheckIn(row.checkIn);
                setCheckOut(row.checkOut);
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
};
